import { DateTime } from 'luxon'

export function dateTimeLong(isoDate: string): string {
  return DateTime.fromISO(isoDate).toLocaleString({
    weekday: 'long',
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
export function dateLong(isoDate: string): string {
  return DateTime.fromISO(isoDate).toLocaleString({
    weekday: 'long',
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
}

export function dateTime(isoDate: string): string {
  return DateTime.fromISO(isoDate).toLocaleString({
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function date(isoDate: string): string {
  return DateTime.fromISO(isoDate).toFormat('dd.MM.yyyy')
}

export function dateWithoutYear(isoDate: string): string {
  return DateTime.fromISO(isoDate).toFormat('dd.MM')
}

export function time(isoDate: string): string {
  return DateTime.fromISO(isoDate).toFormat('HH:mm')
}

export function dateTimeFormatter(isoDate: string): string {
  return DateTime.fromISO(isoDate).toLocaleString(DateTime.DATETIME_MED)
}

/**
 * Function to imitate the 'kaufmännisches Runden' which occurs on server side
 */
export function roundTime(date: DateTime): DateTime {
  const seconds = date.toSeconds()
  const rest = seconds % 60
  if (rest >= 30) {
    const diffSecs = seconds + (60 - rest)
    return DateTime.fromSeconds(diffSecs)
  } else {
    const diffSecs = seconds - rest
    return DateTime.fromSeconds(diffSecs)
  }
}
